/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchAreaV1Dto = {
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the area for internal use
   */
  name?: string | null;
  /**
   * The type of the area.
   */
  type?: PatchAreaV1Dto.type | null;
  /**
   * The type of use of the area.
   */
  typeOfUse?: PatchAreaV1Dto.typeOfUse | null;
  /**
   * The size of the area in square meters
   */
  size?: number | null;
  /**
   * The area is valid from.
   */
  validFrom?: string | null;
  /**
   * The area is valid to.
   */
  validTo?: string | null;
  /**
   * The uuid of the location linked to this area. As 8-4-4-4-12 format.
   */
  locationId?: string | null;
};
export namespace PatchAreaV1Dto {
  /**
   * The type of the area.
   */
  export enum type {
    MAIN_AREA = 'main_area',
    ANCILLARY_AREA = 'ancillary_area',
  }
  /**
   * The type of use of the area.
   */
  export enum typeOfUse {
    SALES = 'sales',
    STORAGE = 'storage',
    AD_SPACE = 'ad_space',
    PARKING_AREA = 'parking_area',
    CONCESSION_AREA = 'concession_area',
    OFFICE_ADMINISTRATION = 'office_administration',
    PRACTICE = 'practice',
    LOGISTIC = 'logistic',
    GASTRONOMY = 'gastronomy',
    OTHER_APARTMENTS = 'other_apartments',
    OTHER_USE = 'other_use',
  }
}
